/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import { WhiteSpace } from "antd-mobile";
import PropTypes from "prop-types";
import { FaFilter } from "react-icons/fa";
import { connect } from "react-redux";
import * as _ from "underscore";
import * as selectors from "../../selectors";
import * as stallAction from "../../actions/stall";
import * as categoryAction from "../../actions/category";
import SearchBarButton from "../../components/SearchBarButton/index";
import StallListing from "../../components/StallListing";
import CategoryBar from "../../components/CategoryBar";
import LoadingIndicator from "../../components/LoadingIndicator";
import FilterModal from "./FilterModal";
import "./index.css";

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
`;

const StyledFilterContainer = styled.div`
  cursor: pointer
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

function closest(el, selector) {
  const matchesSelector =
    el.matches ||
    el.webkitMatchesSelector ||
    el.mozMatchesSelector ||
    el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

class StallListingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterModal: false
    };
  }

  componentDidMount() {
    this.fetchStallDataList();
    this.fetchCategoryDataList();
    this.configureNavBar();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.categoryFilterItem !== this.props.categoryFilterItem ||
      nextProps.selectedFilterData !== this.props.selectedFilterData
    ) {
      this.fetchStallDataList();
    }
  }

  configureNavBar = () => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;
    const navFiler = (
      <StyledFilterContainer onClick={e => this.showModal(e)}>
        <FaFilter size={"1.1em"} />
      </StyledFilterContainer>
    );

    navbarConfig(
      <SearchBarButton {...this.props} />,
      <div />,
      navFiler,
      null,
      null
    );
    showNavbar(true);
    showTabbar(true);
  };

  showModal = e => {
    e.preventDefault();
    this.setState({
      filterModal: true
    });
  };

  onClose = filterResults => {
    const { setStallFilterData } = this.props;

    setStallFilterData && setStallFilterData(filterResults);
    this.setState({
      filterModal: false
    });
  };

  onWrapTouchStart = e => {
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = closest(e.target, ".am-modal-content");
    if (!pNode) {
      e.preventDefault();
    }
  };

  fetchStallDataList = (page, hideLoading = false) => {
    const { getStallListData } = this.props;

    getStallListData(page, hideLoading);
  };

  fetchCategoryDataList = page => {
    const { getCategoryListData } = this.props;

    getCategoryListData(page);
  };

  getLoadingIndicator = () => {
    const { stallLoading, categoryLoading, stallHideLoading } = this.props;

    if (stallHideLoading) {
      return null;
    }

    if (!stallLoading && !categoryLoading) {
      return null;
    }

    return <LoadingIndicator />;
  };

  onCategoryItemClicked = categoryId => {
    const { updateStallCategoryFilter, categoryFilterItem } = this.props;

    const findExistItemIndex = _.indexOf(categoryFilterItem, categoryId);

    let updatedSelectedCategory = _.without(categoryFilterItem, categoryId);

    if (findExistItemIndex === -1) {
      updatedSelectedCategory.push(categoryId);
    }

    updateStallCategoryFilter(updatedSelectedCategory);
  };

  onPressClearCategory = () => {
    const { clearStallCategoryFilter } = this.props;

    clearStallCategoryFilter();
  };

  onCategoryEndReached = () => {
    const { categoryPagination } = this.props;

    if (categoryPagination) {
      const { pageCount, currentPage } = categoryPagination;

      if (currentPage < pageCount) {
        this.fetchCategoryDataList(currentPage + 1);
      }
    }
  };

  onStallEndReached = () => {
    const { stallPagination } = this.props;

    if (stallPagination) {
      const { pageCount, currentPage } = stallPagination;

      if (currentPage < pageCount) {
        this.fetchStallDataList(currentPage + 1, true);
      }
    }
  };

  onStallRefresh = () => {
    this.fetchStallDataList();
  };

  getStallDataList = () => {
    const { stallData } = this.props;
    const emptyData = [{ type: "empty" }];

    return stallData.length > 0 ? stallData : emptyData;
  };

  render() {
    const { filterModal } = this.state;
    const {
      stallData,
      stallDataFilter,
      categoryData,
      categoryFilterItem,
      stallLoading,
      selectedFilterData
    } = this.props;

    return (
      <StyledContainer>
        {this.getLoadingIndicator()}
        <WhiteSpace size={"md"} />
        <FilterModal
          filterData={stallDataFilter}
          selectedFilterData={selectedFilterData}
          shouldShow={filterModal}
          onClose={filterResults => {
            this.onClose(filterResults);
          }}
          onTouchStart={this.onWrapTouchStart}
        />
        <StallListing
          {...this.props}
          items={this.getStallDataList()}
          renderHeader={() => (
            <CategoryBar
              {...this.props}
              items={categoryData}
              showClear={categoryFilterItem.length > 0}
              selectedItem={categoryFilterItem}
              onItemClicked={id => this.onCategoryItemClicked(id)}
              onClearClicked={this.onPressClearCategory}
              onEndReached={this.onCategoryEndReached}
            />
          )}
          onEndReached={this.onStallEndReached}
          showFooterLoading={stallLoading && stallData.length > 0}
          isRefreshing={false}
          onRefresh={this.onStallRefresh}
        />
      </StyledContainer>
    );
  }
}

StallListingPage.propTypes = {
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  stallData: PropTypes.array,
  stallDataFilter: PropTypes.object,
  stallPagination: PropTypes.object,
  stallLoading: PropTypes.bool,
  stallHideLoading: PropTypes.bool,
  categoryData: PropTypes.array,
  categoryPagination: PropTypes.object,
  categoryLoading: PropTypes.bool,
  categoryFilterItem: PropTypes.array,
  selectedFilterData: PropTypes.object,
  getStallListData: PropTypes.func,
  getCategoryListData: PropTypes.func,
  updateStallCategoryFilter: PropTypes.func,
  clearStallCategoryFilter: PropTypes.func,
  setStallFilterData: PropTypes.func
};

function mapStateToProps(state) {
  return {
    stallData: selectors.getStallListData(state),
    stallDataFilter: selectors.getStallListFilter(state),
    stallPagination: selectors.getStallListPagination(state),
    stallLoading: selectors.getStallListLoading(state),
    stallHideLoading: selectors.getStallHideLoading(state),
    categoryData: selectors.getCategoryListData(state),
    categoryPagination: selectors.getCategoryListPagination(state),
    categoryLoading: selectors.getCategoryListLoading(state),
    categoryFilterItem: selectors.getCategoryFilterIDs(state),
    authToken: selectors.getAuthToken(state),
    selectedFilterData: selectors.getStallListFilterData(state),
    stallFoodHideLoading: selectors.getStallFoodHideLoading(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getStallListData: (pageNumber, hideLoading) =>
      dispatch(stallAction.getStallListRequest(pageNumber, hideLoading)),
    getCategoryListData: pageNumber =>
      dispatch(categoryAction.getCategoryListRequest(pageNumber)),
    updateStallCategoryFilter: categoryIDs =>
      dispatch(stallAction.updateStallCategoryFilter(categoryIDs)),
    clearStallCategoryFilter: () =>
      dispatch(stallAction.clearStallCategoryFilter()),
    setStallFilterData: filterData =>
      dispatch(stallAction.setStallFilterData(filterData))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StallListingPage);



// WEBPACK FOOTER //
// ./src/containers/StallListingPage/index.js